import { useContext } from 'react'
import { Avatar } from '@/components/base/avatar'
import {
  Dropdown,
  DropdownButton,
  DropdownDivider,
  DropdownItem,
  DropdownLabel,
  DropdownMenu,
} from '@/components/base/dropdown'
import { NavbarItem } from '@/components/base/navbar'
import { SidebarItem } from '@/components/base/sidebar'
import {
  ArrowRightStartOnRectangleIcon,
  ChevronUpIcon,
  Cog8ToothIcon,
  ShieldCheckIcon,
} from '@heroicons/react/24/solid'
import { CurrentTenantContext } from '@/core/current_tenant_context'
import { AuthContext, IAuthContext } from 'react-oauth2-code-pkce'
import { useNavigate } from 'react-router'

interface Props {
  position: 'sidebar' | 'navbar'
}

export const ProfileDropdown = ({ position }: Props) => {
  const navbar = position == 'navbar'
  const { currentUser } = useContext(CurrentTenantContext)
  const { logOut } = useContext<IAuthContext>(AuthContext)
  const navigate = useNavigate()

  const handleLogout = () => {
    logOut()
    navigate(0)
  }

  if (!currentUser) return <></>

  return (
    <Dropdown>
      {
        navbar
          ? <DropdownButton as={NavbarItem}>
            { currentUser.avatar &&
              <Avatar
                alt={`Avatar for ${currentUser.email}`}
                className="size-10"
                src={currentUser.avatar.url}
                square
              /> }
          </DropdownButton>
          : <DropdownButton as={SidebarItem}>
            <span className="flex min-w-0 items-center gap-3">
              {currentUser.avatar && (
                <Avatar
                  alt={`Avatar for ${currentUser.email}`}
                  className="size-10"
                  src={currentUser.avatar.url}
                  square
                />
              )}
              <span className="min-w-0">
                <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">
                  {currentUser.displayName}
                </span>
                <span className="block truncate text-xs/5 font-normal text-zinc-500 dark:text-zinc-400">
                  {currentUser.email}
                </span>
              </span>
            </span>
            <ChevronUpIcon />
          </DropdownButton>
      }
      <DropdownMenu
        anchor={navbar ? 'bottom end' : 'top start'}
        className="min-w-64"
      >
        {/* <DropdownItem href="/my-profile">
          <UserIcon />
          <DropdownLabel>My profile</DropdownLabel>
        </DropdownItem> */}
        <DropdownItem href="/settings">
          <Cog8ToothIcon />
          <DropdownLabel>Settings</DropdownLabel>
        </DropdownItem>
        <DropdownDivider />
        <DropdownItem href="https://rippleassetmanagement.co.uk/privacy">
          <ShieldCheckIcon />
          <DropdownLabel>Privacy policy</DropdownLabel>
        </DropdownItem>
        {/* <DropdownItem href="/share-feedback">
          <LightBulbIcon />
          <DropdownLabel>Share feedback</DropdownLabel>
        </DropdownItem> */}
        <DropdownDivider />
        <DropdownItem onClick={handleLogout}>
          <ArrowRightStartOnRectangleIcon />
          <DropdownLabel>Sign out</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
